import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  name: null,
  props: null,
};

const modalsSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    openModal: (state, action) => {
      state.name = action.payload.name;
      state.props = action.payload.props;
    },
    closeModal: (state) => {
      state.name = null;
      state.props = null;
    },
  },
});

export const { openModal, closeModal } = modalsSlice.actions;

export const selectOpenModal = (state) => state.modals;

export default modalsSlice.reducer;
